export const SEARCH_START = 'SEARCH_START';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const CSV_DOWNLOAD_START = 'CSV_DOWNLOAD_START';
export const CSV_DOWNLOAD_SUCCESS = 'CSV_DOWNLOAD_SUCCESS';
export const CSV_DOWNLOAD_FAILURE = 'CSV_DOWNLOAD_FAILURE';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
